<div class="split-filter-buttons">
    <ng-container *ngFor="let filter of _filters; let position = index">
        <split-button-filter [filter]="filter" (filterChange)="updateFilter($event, position)"></split-button-filter>
    </ng-container>
</div>

<!--<div class="split-filter-buttons">
    <ng-container *ngFor="let filter of filters; let position = index">
        <p-button size="small"  class="ml-3" [label]="filter.name" [outlined]="active != position" [rounded]="true"  (click)="show(position, op, $event)"></p-button>
        <p-overlayPanel #op (onHide)="hide(position)">
                <ng-container  [ngSwitch]="filter.type">
                    <ng-container *ngSwitchCase="'DROPDOWN'">
                        <split-button-filter #filterButton [id]="filter.id" type="DROPDOWN" [selected]="resultsFilters[position]" [options]="filter.options" (changeSelected)="selected($event, position)"></split-button-filter>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DATE'">
                        <split-button-filter #filterButton [id]="filter.id" class="w-full" [selected]="resultsFilters[position]" type="DATE" (changeSelected)="selected($event, position)"></split-button-filter>
                    </ng-container>
                </ng-container>
        </p-overlayPanel>
    </ng-container>
</div>-->